import React from 'react';
import { HashRouter, Routes, Route } from 'react-router-dom';
import urls from '@/constants/urls';
import Events from '@/auth/hooks/events';
import NotFoundPlaceHolder from '@/home/components/NotFoundPlaceHolder';
import HomeRedirect from '@/routes/HomeRedirect';
import useAddUserToSentry from '@/sentry';
import AuthWrapper from '@/auth/components/AuthWrapper';
import AuthCallback from '@/auth/components/AuthCallback';
import LayoutPage from '@/pages/components/LayoutPage';
import PanelPage from '@/pages/components/PanelPage';
import LogoutPage from '@/pages/components/LogoutPage';

const App = ({ store }) => {
  Events.useSetupAuthProvider(store);
  useAddUserToSentry();

  return (
    <HashRouter>
      <Routes>
        <Route path="/logout" element={<LogoutPage />} />
        <Route path="/authcallback" element={<AuthCallback />} />
        <Route
          path={`${urls.BASE}/*`}
          element={(<AuthWrapper><LayoutPage store={store} /></AuthWrapper>)}
        />
        <Route
          path={`${urls.TAB}/*`}
          element={(<AuthWrapper><PanelPage store={store} /></AuthWrapper>)}
        />
        <Route path="/" element={<HomeRedirect />} />
        <Route path="*" element={<NotFoundPlaceHolder />} />
      </Routes>
    </HashRouter>
  );
};

export default App;
